import { Controller } from '@hotwired/stimulus';

// Makes a whole table row clickable while keeping a real <a> inside for
// accessibility (keyboard, screen readers, cmd/ctrl-click, right-click).
// Replaces the Bootstrap `.stretched-link` trick, which is unreliable in Safari
// because WebKit ignores `position: relative` on <tr>/<td> elements.
export default class extends Controller {
  static values = { url: String }

  navigate(event) {
    if (event.target.closest('a, button')) return;

    if (event.metaKey || event.ctrlKey) {
      window.open(this.urlValue, '_blank');
    } else {
      window.location.href = this.urlValue;
    }
  }
}
